/** 랜딩 섹션 공통 — 프롬프트 스펙 기준 900px 단일 분기 */
export const LANDING_MOBILE_MQ = '@media (max-width: 900px)';

/**
 * 랜딩 타이포 위계 — viewport에 따라 fluid scale (900px 기준 breakpoint와 병행)
 *
 * hero             — 히어로 H1
 * heroLead         — 히어로 서브타이틀
 * display          — 스크롤 인트로 타이틀
 * sectionTitle     — STEP·진행 방법·후기·FAQ 섹션 타이틀
 * sectionTitleSm   — 섹션 안 카드 타이틀
 * introBody        — 섹션 설명, 카드 강조 본문
 * body             — FAQ·후기 본문, 플로팅 메타 값
 * bodyMd           — 진행 방법 카드 설명
 * label            — STEP 배지, 후기 날짜
 * caption          — 말풍선·넛지·플로팅 캡션·플레이스홀더
 * cardName         — 면접관 카드 이름
 * cardQuote        — 면접관 카드 대사
 * micro            — 면접관 카드 태그
 * cta              — CTA 버튼
 */
export const LANDING_FONT = {
  hero: 'clamp(44px, 4.2vw + 26px, 88px)',
  heroLead: 'clamp(18px, 0.8vw + 15px, 26px)',
  display: 'clamp(38px, 4vw + 20px, 52px)',
  sectionTitle: 'clamp(26px, 2.8vw + 14px, 40px)',
  sectionTitleSm: 'clamp(20px, 1.6vw + 14px, 26px)',
  introBody: 'clamp(15px, 1vw + 12px, 18px)',
  body: 'clamp(14px, 0.5vw + 12px, 16px)',
  bodyMd: 'clamp(14px, 0.45vw + 12px, 15.5px)',
  label: 'clamp(13px, 0.45vw + 11px, 15px)',
  caption: 'clamp(12px, 0.35vw + 10px, 14px)',
  cardName: 'clamp(16px, 1.2vw + 11px, 20px)',
  cardQuote: 'clamp(12px, 0.35vw + 10px, 13.5px)',
  micro: 'clamp(10px, 0.25vw + 9px, 11px)',
  cta: 'clamp(14px, 0.5vw + 12px, 16px)',
} as const;

export const LANDING_COLOR = {
  brand: '#00A760',
  brandHover: '#00C471',
  brandActive: '#00915A',
  ink: '#111315',
  dark: '#0E1013',
  bodyMuted: 'rgba(17,19,21,.6)',
  caption: 'rgba(17,19,21,.4)',
  whiteMuted: 'rgba(255,255,255,.55)',
  whiteCaption: 'rgba(255,255,255,.42)',
  body: '#4A4F55',
  subtle: '#6B7178',
  surface: '#F4F6F8',
  line: 'rgba(17,19,21,.1)',
  /** 어두운 배경 위 강조 */
  mint: '#00CCAA',
  /** 흰 배경 위 강조 — mint 는 흰 배경 대비가 낮다 */
  mintDeep: '#0CA678',
  sale: '#FF6B6B',
} as const;

export const LANDING_EASE = '180ms cubic-bezier(.2,0,.2,1)';

/**
 * 랜딩 간격·패딩 위계 — clamp 기반 fluid scale
 *
 * pageX            — 페이지 좌우 인셋
 * sectionY         — STEP·진행 방법·후기·FAQ 섹션 상하
 * blockTop         — 섹션 타이틀 → 본문 블록
 * sectionBottomLg  — FAQ 하단 (플로팅 CTA 여유)
 * rowGap           — FAQ 2열 grid gap
 * rowY             — FAQ 행 세로 padding
 * heroTop / heroX  — 히어로 섹션 패딩
 * introStack       — 인트로·스테이지 상단 margin
 * leadStack        — 히어로 서브타이틀 상단
 * cardCaptionPad   — 면접관 카드 캡션
 * chipPad          — 넛지 padding
 * ctaPadX          — CTA 버튼 좌우
 */
export const LANDING_SPACE = {
  pageX: 'clamp(20px, 4vw, 40px)',
  sectionY: 'clamp(64px, 4vw + 56px, 136px)',
  blockTop: 'clamp(32px, 2vw + 20px, 48px)',
  sectionBottomLg: 'clamp(96px, 12vw + 40px, 140px)',
  rowGap: 'clamp(8px, 2vw + 4px, 24px)',
  rowY: 'clamp(16px, 2vw + 8px, 20px)',
  heroTop: 'clamp(56px, 6vw + 24px, 72px)',
  heroX: 'clamp(20px, 2vw + 12px, 24px)',
  introStack: 'clamp(16px, 2vw + 8px, 24px)',
  leadStack: 'clamp(12px, 1.5vw + 6px, 18px)',
  cardCaptionPad: 'clamp(14px, 1.5vw + 8px, 18px)',
  chipPadY: 'clamp(9px, 0.8vw + 6px, 11px)',
  chipPadX: 'clamp(12px, 1.5vw + 8px, 16px)',
  ctaPadX: 'clamp(20px, 3vw + 8px, 28px)',
  modalPad: 'clamp(16px, 3vw, 20px)',
} as const;
